import { entityFields } from '@/components/services/report-manager/utils'

import render from './render'

export default {
  name: 'Readonly',

  mixins: [ entityFields ],

  props: {
    value: {
      type: Object,
      default: undefined
    },
    service: {
      type: String,
      default: undefined
    }
  },

  render
}

